import { instructorCoursesListActionTypes as types } from 'Screens';
import initialState from 'store/InitialState';

export function instructorCoursesMapReducer(state = initialState.instructorCoursesMap, action) {
    let newState;
    switch(action.type) {
        case types.LOAD_INSTRUCTOR_COURSES_LIST_SUCCESS:
            return action.instructorCoursesMap;
        case types.PUBLISH_COURSE_SUCCESS:
            newState = new Map(state);
            let course = newState.get(action.courseId);
            course.is_published = !course.is_published;
            newState.set(course.id, course);
            return newState;
        case types.DELETE_COURSE_SUCCESS:
            newState = new Map(state);
            newState.delete(action.courseId);
            return newState;
        case types.ADD_COURSE_SUCCESS:
            newState = new Map(state);
            newState.set(action.course.id, action.course);
            return newState;
        case types.IMPORT_COURSE_SUCCESS:
            newState = new Map(state);
            newState.set(action.course.id, action.course);
            return newState;
        case types.DOWNLOAD_COURSE_SUCCESS:
            newState = new Map(state);
            let c = newState.get(action.courseId);
            c.archive.progress = 'Submitted';
            newState.set(c.id,c);
            return newState;
        case types.DELETE_ARCHIVE_SUCCESS:
            newState = new Map(state);
            let arch = newState.get(action.courseId);
            arch.archive.progress = 'not_present';
            arch.archive.active = null;
            arch.archive.link = null;
            newState.set(arch.id, arch);
            return newState;
        case types.LOAD_ARCHIVE_STATUS_SUCCESS:
            newState = new Map(state);
            let crse = newState.get(action.resp.crseid);
            crse.archive = action.resp.arch;
            newState.set(crse.id, crse);
            return newState;
        case types.DISABLE_ARCHIVE_SUCCESS:
            newState = new Map(state);
            let disable_crse = newState.get(action.courseId);
            if(disable_crse.archive.active !=null){
                disable_crse.archive.active = !disable_crse.archive.active;
                newState.set(disable_crse.id, disable_crse);
            }
            return newState;
        default:
            return state;
    }
};

export function instructorInstituteListReducer(state = initialState.instituteList, action) {
    switch(action.type) {
        case types.LOAD_INSTITUTE_LIST_SUCCESS:
            return action.instituteList;
        default:
            return state;
    }
}

export function instructorDepartmentListReducer(state = initialState.instituteList, action) {
    switch(action.type) {
        case types.LOAD_DEPARTMENT_LIST_SUCCESS:
            return action.departmentList;
        default:
            return state;
    }
}

export function instructorImportCoursesListReducer(state = initialState.instructorImportCoursesList, action) {
    switch(action.type) {
        case types.LOAD_IMPORT_COURSES_LIST_SUCCESS:
            return action.data;
        case types.ADD_COURSE_SUCCESS:
            if (state.length !== 0) {
                return [
                    ...state,
                    action.course
                ];
            }
            return state;
        case types.IMPORT_COURSE_SUCCESS:
            return [
                ...state,
                action.course
            ];
        default:
            return state;
    }
};
